export default "<p>legal-mentions works!</p>\r\n"